export enum SituacaoVendedorEnum {
  AtivoSemAcessoSistema = 1,
  Ativo = 2,
  Inativo = 3,
}
